import React, {ReactElement, Component, useContext, useEffect, Dispatch, SetStateAction} from 'react';
import {injectIntl} from 'react-intl';
import {withRouter} from 'react-router-dom';

import {Row} from "antd";
import TableList from "../../components/table-list/table-list";
import {TableDescContext} from "../../contexts/table-desc";
import {http_get, http_request, response_type} from "../../worker/http-func";
import {IUserInfoType, UserInfoContext} from "../../contexts/user-info";
import {ClusterContext, clusters_type_item} from "../../contexts/clusters";
import {WorkspaceContext, workspaces_type_item} from "../../contexts/workspaces";
import {NamespaceContext, namespaces_type_item} from "../../contexts/namespaces";
import {item, ItemsContext} from "../../contexts/items";
import {ClusterSelectedContext} from "../../contexts/cluster-selected";
import {WorkSpaceSelectedContext} from "../../contexts/workspace-selected";
import {NameSpaceSelectedContext} from "../../contexts/namespace-selected";
import {DatacenternameContext} from "../../contexts/datacenter-name";
import {table_list_modal_type, TableListModalTypeContext} from "../../contexts/table_list_modal";

const PVC: React.FC = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {

    const {intl} = props,
        {formatMessage, messages} = intl,
        user_info: IUserInfoType = useContext(UserInfoContext)[0],
        [clusters, set_clusters]: [clusters_type_item[], Dispatch<SetStateAction<clusters_type_item[]>>] = useContext(ClusterContext),
        [workspaces, set_workspaces]: [workspaces_type_item[] | undefined, Dispatch<SetStateAction<workspaces_type_item[] | undefined>>] = useContext(WorkspaceContext),
        [namespaces, set_namespaces]: [namespaces_type_item[] | undefined, Dispatch<SetStateAction<namespaces_type_item[] | undefined>>] = useContext(NamespaceContext),
        set_items: Dispatch<SetStateAction<item[]>> = useContext(ItemsContext)[1],
        [cluster_selected, set_cluster_selected]: [item | undefined, Dispatch<SetStateAction<item | undefined>>] = useContext(ClusterSelectedContext),
        [workspace_selected, set_workspace_selected]: [item | undefined, Dispatch<SetStateAction<item | undefined>>] = useContext(WorkSpaceSelectedContext),
        [namespace_selected, set_namespace_selected]: [item | undefined, Dispatch<SetStateAction<item | undefined>>] = useContext(NameSpaceSelectedContext),
        datacenter_name: string | undefined = useContext(DatacenternameContext)[0],
        set_table_desc: Dispatch<SetStateAction<string[]>> = useContext(TableDescContext)[1],
        table_list_modal: table_list_modal_type = useContext(TableListModalTypeContext)[0];

    useEffect((): void => {
        set_table_desc([`${formatMessage({ id: "pvc" })}`, `${formatMessage({ id: "pvc_desc" })}`]);
        // eslint-disable-next-line
    }, [set_table_desc, messages]);

    useEffect(()=>{
        if(clusters?.length>0){
            const cluster_session: string | null = sessionStorage.getItem('cluster');
            const new_cluster: clusters_type_item | undefined = clusters.find((cluster: clusters_type_item)=> cluster?.metadata?.name === cluster_session);
            set_cluster_selected(new_cluster?.metadata || clusters[0]?.metadata)
        }
        // eslint-disable-next-line
    }, [clusters]);

    useEffect(()=>{
        if(workspaces && workspaces?.length>0){
            const workspace_session: string | null = sessionStorage.getItem('workspace');
            const new_workspace: workspaces_type_item | undefined = workspaces.find((workspace: workspaces_type_item)=> workspace?.metadata?.name === workspace_session);
            set_workspace_selected(new_workspace?.metadata || workspaces[0]?.metadata)
        }
        // eslint-disable-next-line
    }, [workspaces]);

    useEffect(()=>{
        if(namespaces && namespaces?.length>0){
            const namespace_session: string | null = sessionStorage.getItem('namespace');
            const new_namespace: namespaces_type_item | undefined = namespaces.find((namespace: namespaces_type_item)=> namespace?.metadata?.name === namespace_session);
            set_namespace_selected(new_namespace?.metadata || namespaces[0]?.metadata)
        }
        // eslint-disable-next-line
    }, [namespaces]);

    // cluster
    useEffect((): void => {
        user_info.role !== '' && datacenter_name && http_get('pvc_page', ['clusters', set_clusters], user_info.role, user_info.subscription_id, datacenter_name, '');
        // eslint-disable-next-line
    }, [set_clusters, user_info.role, user_info.subscription_id, datacenter_name]);

    // workspace
    useEffect((): void => {
        (async () => {
            if (cluster_selected?.name && datacenter_name) {
                const { name }: item = cluster_selected;
                if ((user_info.role === "workspaceOwner" && user_info.wkOwner_has_namespacedeveloper.includes(cluster_selected?.name)) || user_info.role === 'namespaceDeveloper') {
                    const workspacenames: { name: string; id: string }[] = ((await http_request(
                        "workspacenames",
                        props.history,
                        undefined,
                        `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected.name}/workspacenames`,
                        0,
                        user_info.role,
                        user_info.subscription_id,
                        datacenter_name,
                        cluster_selected.name || "",
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        true
                    )) as response_type).items as { name: string; id: string }[];
                    workspacenames &&
                    set_workspaces(
                        workspacenames.map(({ name, id }) => {
                            return { metadata: { name: id, labels: { name } } } as workspaces_type_item;
                        })
                    );

                }else {
                    name &&
                    user_info.role !== "" &&
                    http_request(
                        "workspaces",
                        props.history,
                        set_workspaces,
                        `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected.name}/workspaces`,
                        0,
                        user_info.role,
                        user_info.subscription_id,
                        datacenter_name,
                        cluster_selected.name || "",
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        true
                    );
                }
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cluster_selected?.name, set_workspaces, user_info.role, user_info.subscription_id, user_info.wkOwner_has_namespacedeveloper]);

    // namespace
    useEffect((): void => {
        (async (): Promise<void> => {
            if (user_info.role !== '' && cluster_selected?.name && workspace_selected?.name && datacenter_name) {
                await http_request(
                    "namespaces",
                    props.history,
                    set_namespaces,
                    `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected?.name}/workspace/${workspace_selected.name}/namespaces`,
                    0,
                    user_info.role,
                    user_info.subscription_id,
                    datacenter_name,
                    cluster_selected?.name,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    true
                );
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user_info.role, user_info.subscription_id, workspace_selected?.name, set_namespaces]);

    const load_pvc = async (dn: any, cn: any, nn: any )=>{
        const pvc_list: any = await http_request(
            "pvc",
            props.history,
            undefined,
            `/v1/datacenter/${dn}/cluster/${cn}/namespace/${nn}/pvcs`,
            0,
            user_info.role,
            user_info.subscription_id,
            dn,
            cn
        );
        if(pvc_list?.items?.length){
            set_items(pvc_list.items)
        }else {
            set_items([]);
        }
    };

    useEffect(()=>{
        if(table_list_modal.pv_yaml_data === 'action_success') {
            const cluster_selected_name: string | undefined = cluster_selected?.name,
                namespace_selected_name: string | undefined = namespace_selected?.name;
            if (cluster_selected_name && namespace_selected_name && datacenter_name) load_pvc(datacenter_name, cluster_selected_name, namespace_selected_name)
        }
        // eslint-disable-next-line
    }, [table_list_modal.pv_yaml_data]);

    useEffect((): void => {
        const cluster_selected_name: string | undefined = cluster_selected?.name,
            namespace_selected_name: string | undefined = namespace_selected?.name;
        if (cluster_selected_name && namespace_selected_name && datacenter_name) load_pvc(datacenter_name, cluster_selected_name, namespace_selected_name)
        else set_items([])
        // eslint-disable-next-line
    }, [namespace_selected?.name, cluster_selected?.name, user_info.role, user_info.subscription_id]);

    return (
        <Row className="px-20 mt-10 no_pointer">
            <TableList />
        </Row>
    )
};

export default injectIntl(withRouter(PVC) as any);
